import {useMount} from '@s-ui/react-hooks'
import Layout from '@adv-mt/mt-layout-basic'
import SpinnerBasic, {spinnerBasicOverlayTypes} from '@adv-mt/mt-spinner-basic'

import LinkFactory from '../../components/LinkFactory/index.js'

const Skeleton = () => {
  useMount(() => {
    window.scrollTo(0, 0)
  })

  return (
    <Layout.Basic linkFactory={LinkFactory} isMarginless isPaddingless>
      <div className="mt-AdsListSubscription-skeleton">
        <SpinnerBasic overlayType={spinnerBasicOverlayTypes.LIGHT} />
      </div>
    </Layout.Basic>
  )
}

export default Skeleton
